import gql from 'graphql-tag';

const QUERY_DOES_ACCOUNT_EXIST = gql`
	query DoesAccountExist($email: String!) {
		doesAccountExist(email: $email)
	}
`;

export default QUERY_DOES_ACCOUNT_EXIST;